export const splitKeywordInput = (input: string): string[] => {
  if (!input) return [];

  const normalized = input
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean)
    .join(' OR ');

  const tokens = normalized.match(/"[^"]*"|\S+/g) ?? [];

  const groups: string[][] = [[]];
  for (const tok of tokens) {
    if (!tok.startsWith('"') && (tok === 'OR' || tok === 'or')) {
      groups.push([]);
    } else {
      groups[groups.length - 1].push(tok);
    }
  }

  const cleaned = groups
    .map((g) => g.join(' ').trim())
    .map((s) => (s.startsWith('"') && s.endsWith('"') ? s.slice(1, -1).trim() : s))
    .filter(Boolean);

  return Array.from(new Set(cleaned));
};
